import { HostingCertificateDomain } from "@modules/graphql/types"

export const stringifyCertDomains = (
  domains: HostingCertificateDomain[] | undefined
) => {
  return domains?.map(domain => domain.id).join(`, `)
}
